$ ->
  if window.tinyMCEbaseURL
    tinyMCE.baseURL = window.tinyMCEbaseURL

init_tinymce = () ->
  $('.tinymce').each ()->
    tinymce_enable($(this), $($(this).data('tmceOwner')), $(this).data('tmceLoadContent'))

editor_queue = {}
drain_queue = (ev)->
  ed = ev.target
  msgs = editor_queue[ed.id]
  if msgs?
    msg = msgs.pop()
    ed.setContent(msg) if msg?
    delete editor_queue[ed.id]

tinymce_enable = (editors, owner, loadContent)->
  return unless tinymce? && editors.length > 0
  editors.each ->
    the_id = $(this).attr('id')
    if the_id?
      settingsKey = if $(this).data('tmcesettingskey')? then $(this).data('tmcesettingskey') else "default"
      settings = window.tinymce_config[settingsKey] || {}
      settings.setup = (ed)->
        ed.on 'init', drain_queue
      if loadContent
        tinymce_set_content(the_id, $("##{the_id}").val())
        unless owner.data('menu_fixer')?
          # this is an ugly hack to fix drop-down menus in TinyMCE when inside a BS Modal. TinyMCE
          # creates each drop-down on-demand, so none of them exist at this moment, but will after the
          # user clicks on a menu item.
          menu_fixer = setInterval ->
            $('body > .mce-floatpanel, body > .mce-tooltip').css(position: 'fixed')
          , 50
          owner.data 'menu_fixer', menu_fixer
      ted = tinymce.get(the_id)
      ted = tinymce.createEditor(the_id, settings) unless ted?
      ted.render()

tinymce_set_content = (id, content)->
  ted = tinymce.get(id)
  if ted? && ted.getDoc()? && !editor_queue[id]?
    ted.setContent(content)
  else
    if editor_queue[id]?
      editor_queue[id].push(content)
    else
      editor_queue[id] = [content]

tinymce_get_content = (id)->
  ted = tinymce.get(id)

  if ted?
    ted.getContent()

tinymce_ready = (id)->
  tinymce.get(id)?

tinymce_disable = (editors, owner)->
  return unless tinymce? && editors.length > 0
  if owner? && owner.data('menu_fixer')?
    clearInterval(owner.data('menu_fixer'))
    owner.data('menu_fixer', null)
  editors.each ->
    the_id = $(this).attr('id')
    if the_id?
      ed = tinymce.get(the_id)
      ed.destroy() if ed?
      tinymce.remove(the_id)


cp_file_picker = (callback, value, meta) ->
  console.log [callback, value, meta]
  tinyMCE.activeEditor.windowManager.open(
    {
      title: 'Choose an Image'
      url: "/#{$("meta[name='level']").attr('content')}/attachments?value=#{value}"
      width: 700
      height: 320
    },
    {
      selectImage: (url) ->
        callback(url, {})
    }
  )

cp_url_converter = (url, elm, on_save, name) ->
  if url.indexOf('{{') > -1 || url.indexOf('{%') > -1
    url
  else
    # lifted from TinyMCE.convertURL because that method will just call us again
    editor = tinyMCE.activeEditor
    settings = editor.settings

    if !settings.convert_urls || (elm && elm.nodeName == 'LINK') ||
       url.indexOf('file:') == 0 || url.length == 0
      return url

    if settings.relative_urls
      return editor.documentBaseURI.toRelative(url)

    editor.documentBaseURI.toAbsolute(url, settings.remove_script_host)

$(->
  if $('#attachment-dialog #attachments .attachment .orig-photo').length > 0
    if parent.tinymce.activeEditor?
      $('#attachment-dialog #attachments .attachment .orig-photo').css('cursor', 'pointer')
    $('#attachment-dialog #attachments .attachment .orig-photo').on 'click', ->
      ed = parent.tinymce.activeEditor
      return unless ed?
      wm = ed.windowManager
      wm.getParams().selectImage $(this).data('url')
      wm.close()
)

module.exports =
  tinymce_enable: tinymce_enable
  tinymce_set_content: tinymce_set_content
  tinymce_ready: tinymce_ready
  tinymce_disable: tinymce_disable
  cp_file_picker: cp_file_picker
  cp_url_converter: cp_url_converter
  tinymce_get_content: tinymce_get_content
  init_tinymce: init_tinymce
